<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("events.title") }}</h5>
    <EventsList
      :tenantId="tenantId"
      :projectId="projectId"
      :date="date"
      mode="event"
    ></EventsList>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import EventsList from "@/components/events/eventsList.vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Breadcrumb,
    EventsList,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const breadcrumb = ref([
      { title: "Home", path: "/" },
      { title: "Event", path: "#", isActive: true },
    ]);
    const tenantId = computed(() => store.getters.tenantId);
    const projectId = computed(() => route.params.projectId);

    return {
      tenantId,
      projectId,
      // tenantId: computed(() => store.getters.tenantId),
      // projectId: computed(() => route.params.projectId),
      breadcrumb,
      date: computed(() => route.query.date),
    };
  },
};
</script>
